
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { clsUser } from '@/types/clsUser';
import { app } from '../main';
import { version } from '../../package.json';

export default defineComponent({
  props: ['user'],
  emits: ['login'],
  setup(_, context) {
    const router = useRouter()
    const route = useRoute()
    const dialogVisible = ref(false)
    const logout = () => {
      const api_path = app.config.globalProperties.api_path
      fetch(api_path + 'ajax/logout.php', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => response.json())
      .then(json => {
        console.log(json);
        context.emit('login', new clsUser())
        if(route.path !== '/') {
          router.push({ path: '/' })
        }
      })
      .catch(error => console.error(error))
    }
    const mypage = () => {
      router.push({ path: '/mypage' })
    }
    const goUsrInfo = () => {
      router.push({ path: '/usrinfo' })
    }
    const goKanri = () => {
      window.location.href = '/tochigi/kanri/'
    }
    onMounted(() => {
      const api_path = app.config.globalProperties.api_path
      fetch(api_path + 'ajax/resession.php', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => response.json())
      .then(json => {
        // バージョンアップ処理
        let reloadCnt = 0
        if(sessionStorage.getItem('reloadCnt')) {
          reloadCnt = Number(sessionStorage.getItem('reloadCnt'))
        }
        if(reloadCnt > 0) {
          if(json.version == version) {
            app.config.globalProperties.$notify({
              title: 'UPDATE',
              message: `Version ${version}に更新されました。`,
              type: 'success'
            })
          }else {
            app.config.globalProperties.$notify({
              title: 'UPDATE',
              message: `Version ${json.version}に更新できませんでした。`,
              type: 'warning'
            })
          }
          sessionStorage.removeItem('reloadCnt')
        }else {
          if(json.version != version) {
            sessionStorage.setItem('reloadCnt', (++reloadCnt).toString())
            location.reload()
          }
        }
        // 自動ログイン処理
        if(json['result'] == 'failure') {
          if(json['error_cd'] == 0) {
            console.log(json.error)
            return
          }else {
            throw new Error(json.error)
          }
        }
        const loginUser = new clsUser()
        loginUser.login = true
        loginUser.name = json['user_name']
        loginUser.email = json['address']
        loginUser.csrf = json['csrf']
        loginUser.admin_flg = json['admin_flg'] == '1'
        loginUser.validmail = json['validmail'] == '1'
        context.emit('login', loginUser)
        if(route.path == '/login') {
          router.push({ path: '/mypage' })
        }
      })
      .catch(error => console.error(error))
    })

    return {
      dialogVisible,
      logout,
      mypage,
      goUsrInfo,
      goKanri
    }
  }
});
